import { Map as ImmMap } from 'immutable';
import Product from 'models/Product';
import ProductFamily from 'models/ProductFamily';
import {
	FETCH_ERROR,
	IS_FETCHING,
	RECEIVE_PRODUCT,
	RECEIVE_PRODUCT_FAMILY,
	RECEIVE_PRODUCT_FAMILY_ON_DISPLAY,
	RECEIVE_PRODUCT_FAMILY_QUANTITY,
	RECEIVE_PRODUCT_ON_DISPLAY,
	RECEIVE_PRODUCT_QUANTITY,
	RECEIVE_RELATED_PRODUCTS,
	RECEIVE_PRODUCT_FAMILY_RELATED_PRODUCTS,
	RECEIVE_PRODUCT_REVIEWS,
	RECEIVE_PRODUCT_FAMILY_REVIEWS,
} from './constants';

export const initialState = new ImmMap({
	fetchError: undefined,
	isFetching: false,
	products: new ImmMap(),
});

const ProductReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_ERROR:
			return state.set('fetchError', action.fetchError);
		case IS_FETCHING:
			return state.set('isFetching', action.isFetching);
		case RECEIVE_PRODUCT: {
			const { lastFetchTime } = action;
			const product = new Product(action.productId, action.product);

			// Each product object is keyed by the productId and contains the time in milliseconds,
			// when it was last fetched and all the details like, name, availability
			return state.mergeIn(['products', action.productId], {
				lastFetchTime,
				product,
			});
		}
		case RECEIVE_PRODUCT_FAMILY: {
			const { lastFetchTime } = action;
			const productFamily = new ProductFamily(action.productFamily);
			const product = new Product(action.productId, {}, productFamily);
			return state.mergeIn(['products', action.productId], { lastFetchTime, product });
		}
		case RECEIVE_PRODUCT_FAMILY_ON_DISPLAY: {
			return state.updateIn(['products', action.productFamilyId, 'product'], currentProduct => {
				// get a new products array from the family products
				const products = currentProduct.family.products.map(
					product =>
						product.id === action.productId
							? { ...product, onDisplay: action.onDisplay, store: action.nopWarehouseId }
							: product,
				);
				// create a new Product instance with the new family
				const family = new ProductFamily({ ...currentProduct.family, products });
				const product = new Product(action.productFamilyId, currentProduct, family);
				return product;
			});
		}
		case RECEIVE_PRODUCT_FAMILY_QUANTITY: {
			const currentProduct = state.getIn(['products', action.productFamilyId, 'product']);
			const updatedFamilyProducts = currentProduct.family.products.map(member => {
				if (member.id === action.productId) {
					const updateMember = member;
					updateMember.stockQuantity = action.quantity;
					return updateMember;
				}
				return member;
			});
			currentProduct.family.products = updatedFamilyProducts;
			const product = new Product(action.productFamilyId, currentProduct, currentProduct.family);
			return state.mergeIn(['products', action.productFamilyId], { product });
		}
		case RECEIVE_PRODUCT_ON_DISPLAY: {
			const currentProduct = state.getIn(['products', action.productId, 'product']);
			currentProduct.store = action.nopWarehouseId;
			currentProduct.onDisplay = action.onDisplay;
			const product = new Product(action.productId, currentProduct);
			return state.mergeIn(['products', action.productId], { product });
		}
		case RECEIVE_PRODUCT_QUANTITY: {
			const currentProduct = state.getIn(['products', action.productId, 'product']);
			currentProduct.stockQuantity = action.quantity;
			const product = new Product(action.productId, currentProduct);
			return state.mergeIn(['products', action.productId], { product });
		}
		case RECEIVE_PRODUCT_REVIEWS: {
			const currentProduct = state.getIn(['products', action.productId, 'product']);
			currentProduct.productReviews = action.productReviews;
			const product = new Product(action.productId, currentProduct);
			return state.mergeIn(['products', action.productId], { product });
		}
		case RECEIVE_RELATED_PRODUCTS: {
			const currentProduct = state.getIn(['products', action.productId, 'product']);
			currentProduct.relatedProducts = action.relatedProducts;
			const product = new Product(action.productId, currentProduct);
			return state.mergeIn(['products', action.productId], { product });
		}
		case RECEIVE_PRODUCT_FAMILY_RELATED_PRODUCTS: {
			return state.updateIn(['products', action.productId, 'product'], currentProduct => {
				// get a new products array from the family products
				const products = currentProduct.family.products.map(product => ({
					...product,
					relatedProducts: action.relatedProducts[product.id],
				}));
				// create a new Product instance with the new family
				const family = new ProductFamily({ ...currentProduct.family, products });
				const product = new Product(action.productId, currentProduct, family);
				return product;
			});
		}
		case RECEIVE_PRODUCT_FAMILY_REVIEWS: {
			const currentProduct = state.getIn(['products', action.productId, 'product']);
			currentProduct.productReviews = action.productReviews;
			const family = new ProductFamily({ ...currentProduct.family });
			const product = new Product(action.productId, currentProduct, family);
			return state.mergeIn(['products', action.productId], { product });
		}
		default:
			return state;
	}
};

export default ProductReducer;
